import { useTranslation } from 'react-i18next';

import { Heading } from '@ctct/presentation-layer';

import { BillingInfoFormWidgetContent } from './BillingInfoFormWidgetContent';
import type { BillingInfoFormWidgetProps } from './useBillingInfoFormWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const BillingInfoFormWidget = ({
  status,
  data,
  handlers,
  hooks,
  billingStrategy,
}: BillingInfoFormWidgetProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <Heading>{t('billing-info-form.heading')}</Heading>
      <WithStatusHandling
        status={status}
        errorMessage={status === 'error' && data instanceof Error ? data.message : undefined}
        retry={status === 'error' && handlers && 'retry' in handlers ? handlers.retry : undefined}
        skeletonHeight={182}
      >
        {status === 'loaded' && (
          <BillingInfoFormWidgetContent
            data={data}
            handlers={handlers}
            hooks={hooks}
            billingStrategy={billingStrategy}
          />
        )}
      </WithStatusHandling>
    </div>
  );
};
